var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasNotAnnounced)?_c('v-btn',{staticClass:"my-5",on:{"click":_vm.handleMail}},[_vm._v("Weekly Reward")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }